import {
    Component,
    Input,
} from '@angular/core';
import { environment } from '../../../../../src/environments/environment'

@Component({
    selector: 'hub-authorization-header',
    templateUrl: './hub-authorization-header.component.html',
    styleUrls: ['./hub-authorization-header.component.scss'],
})
export class HubAuthorizationHeaderComponent {
    public isNewBrand: boolean = environment.isNewBrand

    @Input()
    public showBackButton: boolean = true;

    @Input()
    public onBackClick: () => void;

    @Input()
    public onCloseClick: () => void;
}
